import { PurchaseDocumentStatus } from "../../purchase-documents/purchase-document-statuses/purchase-document-status.model";

export class PurchaseInvoiceHeaderStatus extends PurchaseDocumentStatus {
}
